import { render, staticRenderFns } from "./campaignPopover.vue?vue&type=template&id=54d58882&scoped=true"
import script from "./campaignPopover.vue?vue&type=script&lang=js"
export * from "./campaignPopover.vue?vue&type=script&lang=js"
import style0 from "./campaignPopover.vue?vue&type=style&index=0&id=54d58882&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d58882",
  null
  
)

export default component.exports